import React from 'react';

export const IdentityPanel = ({ form, onChange, subStatus }) => (
  <div className="panel" style={{ padding: 18, marginBottom: 14 }}>
    <div className="field">
      <label>Shop name</label>
      <input
        className="inp"
        value={form.name}
        onChange={(e) => onChange({ name: e.target.value })}
        data-testid="field-name"
      />
    </div>
    <div className="field">
      <label style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 8 }}>
        <span>
          Shop SMS nickname
          <span className="hint">short name used in SMS to keep messages within 1 segment · leave blank to disable SMS</span>
        </span>
        <small
          style={{
            fontFamily: 'var(--ff-num)',
            fontSize: 'var(--fs-xs)',
            color: (form.sms_display_name?.length || 0) > 22 ? 'var(--red)' : 'var(--text-mute)',
            fontWeight: 'var(--fw-medium)',
          }}
          data-testid="field-sms-nickname-count"
        >
          {form.sms_display_name?.length || 0}/22
        </small>
      </label>
      <input
        className="inp"
        value={form.sms_display_name || ''}
        onChange={(e) => onChange({ sms_display_name: e.target.value })}
        placeholder="e.g. Sharp & Sons"
        maxLength={22}
        data-testid="field-sms-nickname"
      />
    </div>
    <div className="field">
      <label>Your booking address <span className="hint">customers visit this link</span></label>
      <div className="inp-sub">
        <input
          value={form.subdomain}
          onChange={(e) => onChange({ subdomain: e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, '') })}
          data-testid="field-subdomain"
        />
        <span className="suffix">.instacut.co.uk</span>
      </div>
      <div className={`sub-status ${subStatus === 'ok' ? 'ok' : subStatus === 'taken' || subStatus === 'invalid' ? 'bad' : 'checking'}`} data-testid="subdomain-status">
        {subStatus === 'checking' && 'Checking availability…'}
        {subStatus === 'ok' && '✓ Available'}
        {subStatus === 'taken' && '✕ That subdomain is taken'}
        {subStatus === 'invalid' && '✕ Use lowercase letters, numbers and hyphens (2–30 chars)'}
        {subStatus === 'idle' && '\u00A0'}
      </div>
    </div>
    <div className="field">
      <label style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 8 }}>
        <span>Tagline <span className="hint">one short line under your shop name</span></span>
        {/* Live counter — muted under the limit, red only when
            exceeding it (protects legacy taglines > 50 chars
            until the owner trims). At the cap the count is
            still muted since the input can't accept more. */}
        <small
          style={{
            fontFamily: 'var(--ff-num)',
            fontSize: 'var(--fs-xs)',
            color: (form.tagline?.length || 0) > 50 ? 'var(--red)' : 'var(--text-mute)',
            fontWeight: 'var(--fw-medium)',
          }}
          data-testid="field-tagline-count"
        >
          {form.tagline?.length || 0}/50
        </small>
      </label>
      <input
        className="inp"
        value={form.tagline}
        onChange={(e) => onChange({ tagline: e.target.value })}
        placeholder="e.g. Considered cuts, quietly done."
        maxLength={50}
        data-testid="field-tagline"
      />
    </div>
    <div className="field" style={{ marginBottom: 0 }}>
      <label>About <span className="hint">intro paragraph on your shop-front</span></label>
      <textarea
        className="inp"
        rows="3"
        value={form.welcome_text}
        onChange={(e) => onChange({ welcome_text: e.target.value })}
        data-testid="field-welcome"
      />
    </div>
  </div>
);
